import React, { useContext, useEffect, useState } from 'react';
import { navigate } from '@reach/router';

import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'

import AuthContext from '../../../services/firebase/AuthContext';
import CloneReferralButton from './CloneReferralButton';
import FireDataContext from '../../../services/firebase/FireDataContext';
import { getAllDataForIntermediary } from './ReferralData';
import MemberMiniMenu from '../menus/MemberMiniMenu';
import ReferralView from './ReferralView';

const ReferralReviewPage = ({ referralId }) => {
    const db = useContext(FireDataContext);
    const { currentUser } = useContext(AuthContext);
    const [digest, setDigest] = useState();

    useEffect(() => {
        try {
            getAllDataForIntermediary({db, currentUser, referralId}).then(data => {
                setDigest(data);
            })
        }
        catch(error) {
            console.log(error);
            navigate("/");
        }

    }, [db, currentUser, referralId]);

    if (!digest) return <></>;

    return (
        <MemberMiniMenu>
            <ReferralView {...digest} />
            <Grid container spacing={2} style={{ marginTop: '1rem'}}>
                <Grid item>
                    <Button onClick={() => navigate(`/casework/quote/${referralId}`)} variant="outlined" color="primary">Start a Quote</Button>
                </Grid>
                <Grid item>
                    <Button onClick={() => navigate(`/casework/referral/decline/${referralId}`)} variant="outlined" color="secondary">Decline this referral</Button>
                </Grid>
                <Grid item>
                    <CloneReferralButton referralId={referralId} />
                </Grid>
            </Grid>
        </MemberMiniMenu>
    );
};

export default ReferralReviewPage;